import {getClosestCulture} from "@/i18n/CurrentCulture";

export interface MultilingualText {
    [lang: string]: string;
}

export interface Multilingual<T> {
    [lang: string]: T;
}

export function toLocal<T>(m: Multilingual<T>) {
    let culture = getClosestCulture(Object.keys(m));
    if (culture == null)
        throw "No applicable culture found";
    return m[culture];
}

export function tryLocal<T>(m: Multilingual<T>) {
    let culture = getClosestCulture(Object.keys(m));
    if (culture == null)
        return null;
    return m[culture];
}

export function toLocalString(ml: MultilingualText): string {
    let culture = getClosestCulture(Object.keys(ml));
    if (culture == null)
        throw "No applicable culture found";
    return ml[culture];
}

export function tryLocalString(ml: MultilingualText): string|null {
    let culture = getClosestCulture(Object.keys(ml));
    if (culture == null)
        return null;
    return ml[culture];
}